import type * as React from 'react'

export function renderExternalLink(href: string) {
  return (chunks: React.ReactNode[]) => (
    <a href={href} target="_blank" rel="noopener noreferrer">{chunks}</a>
  )
}
